import React from "react";
import { shortSeriesDate } from "../../reservas/components/courtSeriesModel";

/* Marca "Fijo" junto al horario de un turno que forma parte de un turno fijo: la misma `odcg-item-series` de Canchas. */
const SerieChip = ({ serie }) => {
  if (!serie?.id) return null;
  const titulo = serie.dateTo ? `Turno fijo hasta el ${shortSeriesDate(serie.dateTo)}` : "Turno fijo";
  return (
    <span className="odcg-item-series ba-serie-chip" title={titulo}>
      Fijo
    </span>
  );
};

export default SerieChip;
